import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";
import { z } from "zod";
import { completeDeviceVersionStringToObject } from "../utils/completeDeviceVersion.js";

extendZodWithOpenApi(z);

/**
 * Zod schema for a complete device version string such as `verdi.4.block.5.a.12`: six dot-separated segments in any
 * case, `?` for an unknown segment, and a known manufacturer.
 */
export const CompleteDeviceVersionString = z
    .string()
    .refine(
        (value) => {
            try {
                completeDeviceVersionStringToObject(value);
                return true;
            } catch {
                return false;
            }
        },
        {
            message: "Must be a complete device version such as verdi.4.block.5.a.12, with ? for an unknown segment",
        },
    )
    .openapi({
        type: "string",
        description: "Complete device version: six dot-separated segments, ? for an unknown segment",
        example: "verdi.4.block.5.a.12",
    });
